import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseDaoService} from '@q9elements/ui-kit/common';
import {Observable} from 'rxjs';

interface SearchQuery {
  skip: number;
  limit: number;
  type?: string;
}

@Injectable({
  providedIn: 'root'
})
export class StakeholdersDaoService extends BaseDaoService {
  public getUserSfNodes(refModel: string, query: SearchQuery): Observable<any> {
    const params = new HttpParams()
      .set('skip', String(query.skip))
      .set('limit', String(query.limit))
      .set('type', query.type);
    return this.http.get(`${this.apiUrl}/stakeholders/sf/refmodel/${refModel}/my-metadata`, {
      params
    });
  }

  public getUserRefNodes(refModel: string, query: SearchQuery): Observable<any> {
    const params = new HttpParams()
      .set('skip', String(query.skip))
      .set('limit', String(query.limit))
      .set('type', query.type);
    return this.http.get(`${this.apiUrl}/stakeholders/ref/refmodel/${refModel}/my-metadata`, {
      params
    });
  }
}
